import(/* webpackMode: "eager" */ "/codebuild/output/src1898816064/src/treeunfe-website-nextjs/node_modules/next/dist/client/image-component.js");
